import { User } from "./user";

export class Paiement {

    id: number;
    date_create: string;
    user: User;
    montant: number;
    is_valided: boolean;


    get nameUser(): string {

        if(this.user !== undefined && this.user !== null)
        return this.user.name;
        else
        return '';
    }




}
